import React from "react";
// import StyledButton from "../../../common/models/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DialogContent from "@material-ui/core/DialogContent";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// Icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Button, makeStyles } from "@material-ui/core";
const useStyles = makeStyles({
  closeText: {
    fontSize: "1rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  saved: {
    textAlign: "center",
    padding: "0.5rem",
    fontWeight: 500,
    fontSize: "1.5rem",
  },
  text: {
    textAlign: "center",
    fontSize: "0.9rem",
    marginBottom: "1rem",
  },
  iconGrid: {
    display: "flex",
    justifyContent: "center",
  },
  icon: {
    fontSize: "3.5rem",
    color: "#39811D",
  },
  tableContainer: {
    marginTop: "1.5rem",
    marginBottom: "1.5rem",
    border: "2px solid #D0D0D0",
  },
  tableHeader: {
    fontWeight: "normal",
    backgroundColor: "#F5F5F5",
    borderBottom: "1px solid #D0D0D0",
  },
  okButton: {
    backgroundColor: "#ec6535", // Orange background
    color: "white", // White text
    textTransform: "none", // Remove uppercase transform
    padding: "8px 0px", // Adjust padding for pill shape
    // minWidth: "100px", // optional, set min width for button
    borderRadius: "20px", // Slightly rounded corners
    "&:hover": {
      backgroundColor: "#ec6535", // Darker orange on hover
    },
  },
});
const StyaledDialog = ({
  title,
  subtitle,
  icon,
  handleClose,
  isButtonDisabled,
  tableData,
}) => {
  const classes = useStyles();
  const tableArray = [
    {
      header: "Material Code",
    },
    {
      header: "Material Name",
    },
  ];
  return (
    <DialogContent>
      <Grid container justifyContent="flex-end">
        <Grid item xs={12} className={classes.iconGrid}>
          {icon === true ? (
            <CancelIcon className={classes.icon} style={{ color: "red" }} />
          ) : (
            <CheckCircleIcon className={classes.icon} />
          )}
        </Grid>
      </Grid>
      <Typography variant="h5" className={classes.saved}>
        {title}
      </Typography>
      <Typography variant="body2" className={classes.text}>
        {subtitle}
      </Typography>

      <Grid item xs={12} style={{ textAlign: "center", paddingBottom: "2rem" }}>
        <Button
          //   style={{ padding: "0.2rem 2rem" }}
          onClick={handleClose}
          className={classes.okButton}
          disabled={isButtonDisabled}
          size="small"
        >
          Ok
          <ArrowForwardIosIcon
            style={{ fontSize: "0.9rem", color: "white", marginLeft: "0.2em" }}
          />
        </Button>
      </Grid>
    </DialogContent>
  );
};
export default StyaledDialog;
